interface ParamSliderProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
  presets?: { label: string; value: number }[];
}

export function ParamSlider({
  label,
  value,
  onChange,
  min,
  max,
  step,
  presets,
}: ParamSliderProps) {
  return (
    <div className="param-slider">
      <div className="param-slider-head">
        <span className="param-slider-lbl">{label}</span>
        <span className="param-slider-val">{value}</span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="param-slider-range"
      />
      {presets && presets.length > 0 && (
        <div className="param-slider-presets">
          {presets.map((preset) => (
            <button
              key={preset.label}
              type="button"
              onClick={() => onChange(preset.value)}
              className={`param-preset${value === preset.value ? " on" : ""}`}
            >
              {preset.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
